export type companyRoles = 'broker' | 'client' | 'vendor'

export const BROKER = 'broker' as companyRoles
export const VENDOR = 'vendor' as companyRoles
export const CLIENT = 'client' as companyRoles

export const ADMIN_WITH_COMPANY_SETTINGS = 'Admin With Company Settings'
